

export const CLOCK_PROFILES = {
  football_pls: {
    firstHalfLimit: 9999,
    secondHalfLimit: 9999,
    // Fixed period-end snap targets (45:00 / 90:00) used when a half ends —
    // independent of firstHalfLimit/secondHalfLimit above, which stay
    // uncapped so the *running* clock can keep ticking past 45:00 during
    // unannounced stoppage time before the operator ends the half.
    firstHalfEndSeconds: 2700,
    secondHalfEndSeconds: 5400,
    periodToNextOption: {
      'PRE-GAME':    'startFirstHalf',
      'FIRST HALF':  'endFirstHalf',
      'HALF TIME':   'startSecondHalf',
      'SECOND HALF': 'endSecondHalf',
      'FULL TIME':   'reset',
    },
  },

  default: {
    firstHalfLimit: 2700,
    secondHalfLimit: 5400,
    firstHalfEndSeconds: 2700,
    secondHalfEndSeconds: 5400,
    periodToNextOption: {
      'PRE-GAME':    'startFirstHalf',
      'FIRST HALF':  'endFirstHalf',
      'HALF TIME':   'startSecondHalf',
      'SECOND HALF': 'endSecondHalf',
      'FULL TIME':   'reset',
    },
  },
};

export const getClockProfile = (profileId) =>
  CLOCK_PROFILES[profileId] ?? CLOCK_PROFILES.default;
